"use client";

import { MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServiceArea() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const mapsUrl = "https://www.google.com/maps/search/?api=1&query=Ideal+Image+Aesthetics+Wellness";
  return <section data-section-id="9892" id="service-area" className="bg-background text-foreground py-8 md:py-16">
      <div className="mx-auto w-full max-w-[1080px] px-6 md:px-8">
        <div ref={ref} className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-12 md:gap-16 items-center">
          <div className={`md:col-span-2 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionTimingFunction: "cubic-bezier(0.22, 0.61, 0.36, 1)"
        }}>
            <p className="font-default text-sm font-bold tracking-[0.2em] uppercase mb-6 text-accent-foreground">
              Concierge Care
            </p>

            <h2 className="font-default font-medium text-foreground text-2xl sm:text-3xl md:text-4xl leading-[1.2] tracking-[-0.01em] mb-8">
              Refined{" "}
              <em className={`italic transition-opacity duration-500 ${isVisible ? "opacity-100" : "opacity-0"}`} style={{
              transitionDelay: "200ms"
            }}>
                facial balancing
              </em>{" "}
              designed for you.
            </h2>

            <p className="font-default text-[1.25rem] leading-[1.7] font-normal mb-10 text-chart-2">
              Experience the luxury of private, personalized aesthetic care. Whether you are seeking preventative filler to smooth early lines or refined Botox to restore natural symmetry, our concierge approach ensures a seamless, high-quality experience without the wait.
            </p>

            <div className="mb-8">
              <h3 className="font-default text-foreground text-[clamp(1.125rem,1.3vw,1.25rem)] font-medium leading-[1.4] mb-3">
                Our Private Suite
              </h3>
              <p className="font-default text-[17px] leading-[1.7] text-foreground mb-3">
                26610 U.S. Hwy 281 N #109,
                <br />
                San Antonio, TX 78260
              </p>
              <Link to={mapsUrl} newTab className="inline-flex items-center gap-1 font-default text-[17px] text-foreground hover:opacity-80 transition-opacity duration-200" style={{
              textDecoration: "underline",
              textDecorationColor: "hsl(15 45% 75%)",
              textUnderlineOffset: "6px"
            }}>
                <MapPin className="size-4 text-primary" aria-hidden="true" />
                Get directions →
              </Link>
            </div>

            <Separator className="w-2/5 mb-8 bg-border" />

            <div className="mb-10">
              <h3 className="font-default text-foreground text-[clamp(1.125rem,1.3vw,1.25rem)] font-medium leading-[1.4] mb-3">
                Concierge Hours
              </h3>
              <div className="font-default text-[17px] leading-[1.7] text-foreground space-y-1">
                <p>{"Mon–Fri · By Appointment"}</p>
                <p>{"Sat · Exclusive Sessions"}</p>
                <p>{"Sun · Private Consultations"}</p>
              </div>
            </div>

            <Link to="https://my.portraitcare.com/booking/?business_id=jr3uOp" newTab={true} className="inline-block w-full sm:w-auto">
              <Button variant="outline" target="_blank" className="w-full sm:w-auto bg-primary rounded-lg px-8 py-[18px] min-h-[56px] text-[17px] font-medium font-default hover:bg-primary/90 transition-all duration-200 border-none text-foreground">
                Schedule your consultation
              </Button>
            </Link>
          </div>

          <div className={`md:col-span-1 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: "120ms",
          transitionTimingFunction: "cubic-bezier(0.22, 0.61, 0.36, 1)"
        }}>
            <div className="rounded-3xl p-3 md:p-6 group bg-card">
              <div className="overflow-hidden rounded-2xl">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711910/img/aesthetic_clinic_interior.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711910/img/aesthetic_clinic_interior.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711910/img/aesthetic_clinic_interior.png-wvc-sizes" alt="Sophisticated and minimalist aesthetic clinic interior with soft lighting" loading="lazy" decoding="async" className="w-full h-auto aspect-[4/5] object-cover transition-transform duration-[600ms] ease-out group-hover:scale-[1.03]" style={{
                transitionTimingFunction: "cubic-bezier(0.22, 0.61, 0.36, 1)"
              }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}